import { UserNameInfo } from "src/flowContainer/versionEditedInfo/UsernameInfo";
import { useCurrentUserId } from "src/store/AuthStore";

export const UpdatedByInfo = ({ updatedBy }: { updatedBy?: string }) => {
  const userId = useCurrentUserId();

  if (updatedBy === undefined) return null;
  if (userId === updatedBy) return <> by you</>;
  return (
    <>
      by <UserNameInfo userId={updatedBy} />
    </>
  );
};
